import { render } from "./BankAutocompleteSuggestion.vue?vue&type=template&id=1095aa03"
import script from "./BankAutocompleteSuggestion.vue?vue&type=script&lang=js"
export * from "./BankAutocompleteSuggestion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__